import { useRouter } from "next/router";
import { useEffect } from "react";
import { DropdownOption } from "ui";
import { scenarioTypeOptions, useSandbox } from "../SandboxProvider";
import { Scenario } from "../types";
import {
  compressString,
  decompressString,
} from "../../../utils/compressString";
import isEqual from "lodash.isequal";

export const useSandboxHistory = () => {
  const router = useRouter();
  const {
    account,
    setAccount,
    accountApiKey,
    setAccountApiKey,
    type,
    setType,
    scenario,
    setScenario,
    editor,
    setEditor,
    urlValues,
    setUrlValues,
    sandboxConfig,
  } = useSandbox();

  const sandboxState = {
    account,
    accountApiKey,
    type: type[0],
    scenario: scenario?.[0],
    editor,
    urlValues,
  };

  const updateSandboxState = (state: any) => {
    if (account[0] !== state.account[0]) setAccount(state.account);
    if (accountApiKey?.[0] !== state.accountApiKey[0])
      setTimeout(() => setAccountApiKey(state.accountApiKey), 500);

    if (type[0] !== state.type) {
      const typeOption = scenarioTypeOptions.find(
        (option) => option[0] === state.type
      );
      setType(typeOption!);
    }

    if (scenario?.[0] !== state.scenario) {
      const scenarios = Object.entries(sandboxConfig?.scenarios ?? {}).map(
        ([key, value]) => [key, { ...(value as any), label: key }]
      );
      const scenario = scenarios.find(
        (scenario) => scenario[0] === state.scenario
      ) as DropdownOption<Scenario>;
      setScenario(scenario!);
    }

    if (editor !== state.editor) setTimeout(() => setEditor(state.editor), 500);

    if (!isEqual(urlValues, state.urlValues))
      setTimeout(() => setUrlValues(state.urlValues), 500);
  };

  useEffect(() => {
    const { state } = router.query;

    if (!state) return;

    const stateObj = JSON.parse(
      decompressString(decodeURIComponent(state as string))
    );

    updateSandboxState(stateObj);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query]);

  const updateUrlState = (state: any) => {
    const compressedState = compressString(
      JSON.stringify({
        ...state,
        scenario: state.scenario,
        type: state.type,
      })
    );

    router.push({
      search: `state=${encodeURIComponent(compressedState)}`,
    });
  };

  return { sandboxState, updateUrlState, updateSandboxState };
};
